export default __webpack_public_path__ + "static/media/time.b56c3e62.svg";